var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.runbook_url)?_c('a',{attrs:{"rel":"nofollow noopener noreferrer","target":"_blank","href":_vm.value.runbook_url}},[_vm._v(_vm._s(_vm.value.message || _vm.value.description)+" "),_c('i',{staticClass:"icon icon-external-link"})]):_c('span',[_vm._v(_vm._s(_vm.value.message || _vm.value.description))])
}
var staticRenderFns = []

export { render, staticRenderFns }